import { DaoService } from "./DaoService";

export class DashboardService extends DaoService {
  static getInstance() {
    return super.getInstance("dashboard");
  }

  async getMyNumbers(data) {
    return DashboardService.post(`${this.prefix}/my-numbers`, data);
  }

  async getMyLatestAffaires() {
    return DashboardService.get(`${this.prefix}/my-latest-affaires`);
  }

  async getMyLatestTaches() {
    return DashboardService.get(`${this.prefix}/my-latest-taches`);
  }

  async getFeed(page = 1, filters = {}) {
    const params = new URLSearchParams({ page });
    Object.entries(filters).forEach(([k, v]) => { if (v != null && v !== '') params.set(k, v); });
    return DashboardService.get(`${this.prefix}/feed?${params.toString()}`);
  }

  async getMyOverdueTaches() {
    return DashboardService.post(`${this.prefix}/my-overdue-taches`, {});
  }

  async getMyUrgentAffaires() {
    return DashboardService.post(`${this.prefix}/my-urgent-affaires`, {});
  }

  async getAssignedByMe(data) {
    return DashboardService.post(`${this.prefix}/assigned-by-me`, data);
  }

  async getMyActivity(data) {
    return DashboardService.post(`${this.prefix}/my-activity`, data);
  }
}
